import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tariff-main-option" }
const _hoisted_2 = { class: "tariff-main-option__wrapper" }
const _hoisted_3 = { class: "tariff-main-option__value h3 color-white" }
const _hoisted_4 = { class: "tariff-main-option__maximum caption-small normal color-text-tertiary" }

import { computed } from "vue";
import { PropType } from "@vue/runtime-core";
import { TariffOptionStruct } from "@/struct/TariffStruct";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'TariffMainOption',
  props: {
  option: {
    type: Object as PropType<TariffOptionStruct>,
    required: true,
  },
},
  setup(__props) {

const props = __props;
const { t } = useI18n();

const getUnit = computed(() => {
  switch (props.option.id) {
    case "sms":
      return t("common.units.sms");
    case "gb":
      return t("common.units.gb");
    case "min":
      return t("common.units.min");
    default:
      return "";
  }
});

const fullness = computed(() => {
  return Math.floor(100 - (props.option?.value / props.option?.maximum) * 100);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(`width: ${fullness.value}%`),
      class: "tariff-main-option__progress"
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(__props.option.value) + " " + _toDisplayString(getUnit.value), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)("common.labels.of")) + " " + _toDisplayString(__props.option.maximum), 1)
      ])
    ])
  ]))
}
}

})